import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormSection, Field } from '../../../libs/reduxForm';
import { Checkbox, CurrencyDropdownField, DateField, DunsNumberAbbr, IndustryDropdownField, ImportsExportsDropdownField, LegalRepresentativeArrayField, LegalStructureDropdownField, ShareholderArrayField, TextField, YesNoField } from '../../../components';
import { shareholderTypes } from '../../../constants';
import FilesSectionBrazil from './brazil/Files';
import FilesSectionMexico from './mexico/Files';
import FilesSectionArgentina from './argentina/Files';
import FilesSectionPeru from './peru/Files';
import FilesSectionCCS from './ccs/Files';
import { Validation } from '../../../services';
import './steps.css';

var AddRepresentativeButton = function AddRepresentativeButton(_ref) {
  var fields = _ref.fields;
  return React.createElement('button', {
    type: 'button',
    className: 'Btn-outline-primary Btn-outline-small',
    onClick: function onClick() {
      return fields.push();
    }
  }, 'Add representative');
};

var RemoveItemButton = function RemoveItemButton(_ref2) {
  var fields = _ref2.fields,
      index = _ref2.index;
  return React.createElement('div', {
    className: 'ArrayField__removeBtn'
  }, React.createElement('button', {
    className: 'Btn-outline-danger Btn-outline-small',
    type: 'button',
    onClick: function onClick() {
      return fields.remove(index);
    }
  }, React.createElement('i', {
    className: 'icon-ic_close'
  }), '\xA0Remove'));
};

var AddShareholderButtons = function AddShareholderButtons(_ref3) {
  var fields = _ref3.fields;
  return React.createElement(Fragment, null, React.createElement('button', {
    type: 'button',
    className: 'Btn-outline-primary Btn-outline-small',
    onClick: function onClick() {
      return fields.push({
        type: shareholderTypes.INDIVIDUAL
      });
    }
  }, 'Add Shareholder (Legal Individual)'), React.createElement('button', {
    type: 'button',
    className: 'Btn-outline-primary Btn-outline-small',
    onClick: function onClick() {
      return fields.push({
        type: shareholderTypes.COMPANY
      });
    }
  }, 'Add Shareholder (Company)'));
};

var OperationsStep = /*#__PURE__*/function (_Component) {
  _inherits(OperationsStep, _Component);

  function OperationsStep() {
    _classCallCheck(this, OperationsStep);

    return _possibleConstructorReturn(this, _getPrototypeOf(OperationsStep).apply(this, arguments));
  }

  _createClass(OperationsStep, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          selectedCountryRegionName = _this$props.selectedCountryRegionName,
          selectedLegalStructure = _this$props.selectedLegalStructure,
          onFileUpload = _this$props.onFileUpload,
          onFileDelete = _this$props.onFileDelete,
          metadata = _this$props.metadata,
          isUserLegalRepresentative = _this$props.isUserLegalRepresentative,
          user = _this$props.user,
          fileMap = _this$props.fileMap,
          fileState = _this$props.fileState;
      return React.createElement(Fragment, null, React.createElement('h4', null, React.createElement('b', null, 'Great!'), ' Please fill out the fields below to begin the process of receiving a ', React.createElement(DunsNumberAbbr, null), '.'), React.createElement(FormSection, {
        name: 'company.business'
      }, React.createElement('h2', null, 'Operation details'), React.createElement(IndustryDropdownField, {
        label: 'What type of business do you do?*',
        name: 'line_of_business',
        placeholder: 'Select one of the following',
        validate: [Validation.required]
      }), React.createElement(TextField, {
        label: 'Total amount of employees*',
        name: 'employees_count',
        placeholder: 'Enter total amount of employees',
        type: 'number',
        validate: [Validation.required, Validation.isIntegerGreaterThenZero]
      }), React.createElement(ImportsExportsDropdownField, {
        isClearable: true,
        label: 'Does your company import or export?',
        name: 'imports_exports',
        placeholder: 'Select one of the following'
      }), React.createElement('h2', null, 'Corporate information'), React.createElement(LegalStructureDropdownField, {
        isClearable: true,
        label: 'Legal Structure',
        name: 'legal_structure',
        placeholder: 'Select one of the following',
        regionName: selectedCountryRegionName
      })), selectedLegalStructure === 'Other' && React.createElement(TextField, {
        label: 'Other Legal Structure',
        name: 'otherLegalStructure',
        placeholder: 'Other Legal Structure'
      }), React.createElement('div', {
        className: 'GetDunsNumberForm-currencyDropdown'
      }, React.createElement(CurrencyDropdownField, {
        label: 'Currency',
        name: 'company.business.sales.currency',
        placeholder: 'Select one of the following'
      })), React.createElement('div', {
        className: 'GetDunsNumberForm-operationStep'
      }, React.createElement(TextField, {
        label: 'Annual sales',
        type: 'number',
        name: 'company.business.sales.volume',
        placeholder: 'Enter Annual sales(amount)',
        validate: [Validation.isIntegerGreaterThenZero]
      })), React.createElement(DateField, {
        label: 'Foundation date',
        name: 'company.founded',
        placeholder: 'Enter Foundation date'
      }), // Only for Brazil
      metadata.isDunsForBrazil && React.createElement(TextField, {
        label: 'Business Registration Identification Number (NIRE)',
        name: 'company.brazil_extras.nire_number',
        placeholder: 'Enter NIRE Number'
      }), React.createElement('h2', null, 'Legal Representatives'), React.createElement(YesNoField, {
        label: 'Are you a Legal Representative of your business (included in Articles of Incorporation/ata constitutiva)',
        name: 'company.user_is_legal_representative'
      }), isUserLegalRepresentative === 'no' && React.createElement(Fragment, null, React.createElement('p', null, 'Please list a Legal Representative of your business (included in Articles of Incorporation/ata constitutiva)'), React.createElement(LegalRepresentativeArrayField, {
        startWithOneItem: true,
        name: 'company.personnel',
        AddButton: AddRepresentativeButton,
        RemoveButton: RemoveItemButton
      })), React.createElement('h2', null, 'Shareholders'), React.createElement(ShareholderArrayField, {
        name: 'company.shareholders',
        user: user,
        AddButton: AddShareholderButtons,
        RemoveButton: RemoveItemButton
      }), React.createElement('h2', null, 'Files'), metadata.isDunsForBrazil && React.createElement(FilesSectionBrazil, {
        fileMap: fileMap,
        fileState: fileState,
        onFileUpload: onFileUpload,
        onFileDelete: onFileDelete
      }), metadata.isDunsForMexico && React.createElement(FilesSectionMexico, {
        fileMap: fileMap,
        fileState: fileState,
        onFileUpload: onFileUpload,
        onFileDelete: onFileDelete
      }), metadata.isDunsForArgentinaArea && React.createElement(FilesSectionArgentina, {
        fileMap: fileMap,
        fileState: fileState,
        onFileUpload: onFileUpload,
        onFileDelete: onFileDelete
      }), metadata.isDunsForPeruArea && React.createElement(FilesSectionPeru, {
        fileMap: fileMap,
        fileState: fileState,
        onFileUpload: onFileUpload,
        onFileDelete: onFileDelete
      }), // Must not match Argentina and Peru area country
      // because some of them are also included in CCS list.
      // We already cover that specific cases above.
      !metadata.isDunsForArgentinaArea && !metadata.isDunsForPeruArea && metadata.isDunsForCCS && React.createElement(FilesSectionCCS, {
        fileMap: fileMap,
        fileState: fileState,
        onFileUpload: onFileUpload,
        onFileDelete: onFileDelete
      }), React.createElement('div', {
        className: 'row mtop-30'
      }, React.createElement('div', {
        className: 'col-md-12'
      }, React.createElement('div', {
        className: 'form-group mtop-30'
      }, React.createElement(TextField, {
        label: 'Name',
        placeholder: 'Name',
        name: 'account.name',
        validate: [Validation.required]
      })), React.createElement('div', {
        className: 'form-group mtop-30'
      }, React.createElement(TextField, {
        disabled: true,
        label: React.createElement('span', {
          className: 'TaggedLabel'
        }, React.createElement('span', null, 'E-mail'), React.createElement('span', {
          className: 'label label-success'
        }, 'Confirmed')),
        placeholder: 'E-mail',
        name: 'account.email',
        validate: [Validation.required]
      })), React.createElement('div', {
        className: 'form-group mtop-30'
      }, React.createElement('div', {
        className: 'row'
      }, React.createElement('div', {
        className: 'col-md-8'
      }, React.createElement(TextField, {
        label: 'Phone',
        name: 'account.phone',
        placeholder: 'Enter phone number'
      })), React.createElement('div', {
        className: 'col-md-4'
      }, React.createElement(TextField, {
        label: 'Extension',
        name: 'account.phoneExt',
        placeholder: 'Enter phone extension'
      })))), React.createElement('div', {
        className: 'form-group mtop-30'
      }, React.createElement('div', {
        className: 'checkbox checkbox-info'
      }, React.createElement(Field, {
        label: '\xA0 I confirm that the information given in this form is true, complete, and accurate.',
        name: 'acceptLegal',
        type: 'checkbox',
        component: Checkbox
      })))), React.createElement('div', {
        className: 'col-md-12'
      }, 'There is a possibility that additional information will be requested on the confirmation call.')));
    }
  }]);

  return OperationsStep;
}(Component);

OperationsStep.propTypes = {
  selectedCountryRegionName: PropTypes.string.isRequired,
  selectedLegalStructure: PropTypes.string,
  onFileUpload: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired,
  metadata: PropTypes.object.isRequired,
  isUserLegalRepresentative: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  fileMap: PropTypes.object.isRequired,
  fileState: PropTypes.object.isRequired
};
export default OperationsStep;